<template>
  <el-dialog
    class="previewDialogBox"
    :visible.sync="dialogVisible"
    width="860px"
    :append-to-body="true"
    :show-close="false"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :lock-scroll="false"
    :custom-class="'previewDialogContainer'"
    :destroy-on-close="true"
  >
    <div class="title">
      <div>
        <span class="title-h3">预览</span>
        <span class="title-desc">左右滑动可查看处理前后效果对比图</span>
      </div>
      <i class="el-icon-close closeIcon" @click="handleClose"></i>
    </div>
    <div
      id="cover"
      onpaste="return false"
      oncontextmenu="return false"
      oncopy="return false"
      oncut="return false"
      class="cover"
    >
      <div class="cover-main compress">
        <span class="cd-image-label" style="left: 16px">
          原图{{ currentFileInfo?.origin?.width }} X
          {{ currentFileInfo?.origin?.height }}</span
        >
        <span class="cd-image-label" style="right: 16px"
          >{{ molti }}X | {{ currentFileInfo?.origin?.width * molti }} X
          {{ currentFileInfo?.origin?.height * molti }}</span
        >
        <div
          :class="{
            imageContainer: true,
            scaleHeight:
              currentFileInfo?.origin?.width >= currentFileInfo?.origin?.height
          }"
        >
          <div class="figureBox" :style="{ width: position + 'px' }">
            <div class="imgBox" v-if="loading == false">
              <img
                :draggable="false"
                :src="currentFileInfo?.origin?.src"
                alt=""
                class="nowImg"
              />
            </div>
          </div>
          <div class="loader" v-if="loading">
            <div class="spinner-3"></div>
            <div style="margin-top:20px;">AI正在处理中 <span class="dots-1">...</span> </div>
            <div style="margin-top:10px;font-size: 12px;">云端处理速度与网络速度和图片大小有关，请耐心等待~</div>
          </div>
          <img
            :draggable="false"
            :src="currentFileInfo?.target?.src"
            alt=""
            class="originImg"
            :style="`height: ${currentFileInfo?.origin?.height}px`"
            @load="onImageLoad"
            loading="lazy"
          />
          <div
            class="moveBtn"
            v-if="loading == false"
            :style="{ left: position + 'px' }"
          >
            <div class="move" @mousedown="figureMouseDown"></div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'PreviewModal',
  components: {},
  props: {
    molti: {
      type: String,
      default: '0'
    },
    fileInfo: Object,
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dragging: false,
      position: `calc(50% - 20px)`,
      currentFileInfo: {},
      loading: true // 初始状态为加载中
    }
  },
  watch: {
    fileInfo: {
      handler(val) {
        this.currentFileInfo = val
      },
      immediate: true,
      deep: true
      // 提交
    }
  },
  computed: {
    beforeWidth() {
      document
        .getElementById('originImg')
        .addEventListener('load', function () {
          // 隐藏遮罩层
          document.getElementById('loader').style.display = 'none'
        })
      // this.loading = false
    }
  },

  methods: {
    onImageLoad() {
      // 图片加载完成后隐藏遮罩层
      this.loading = false
    },

    handleClose() {
      this.dragging = false
      this.position = `calc(50% - 20px`
      this.$emit('onClose')
    },
    figureMouseDown(event) {
      this.dragging = true
      const clientX = event.clientX || event.touches[0].clientX

      const container = this.$el.querySelector('.imageContainer')
      const containerLeft = container.getBoundingClientRect().left
      const figureBox = this.$el.querySelector('.move')
      const figureBoxWidth = figureBox.clientWidth + 2 // 2是因为 border宽度

      const newPosition = clientX - containerLeft

      this.position = Math.max(
        figureBoxWidth / 2,
        Math.min(container.offsetWidth - figureBoxWidth / 2, newPosition)
      )

      document.addEventListener('mousemove', this.drag)
      document.addEventListener('touchmove', this.drag, { passive: false })
      document.addEventListener('mouseup', this.stopDrag)
      document.addEventListener('touchend', this.stopDrag)
    },
    drag(event) {
      if (this.dragging) {
        const clientX = event.clientX || event.touches[0].clientX
        const container = this.$el.querySelector('.imageContainer')
        const containerLeft = container.getBoundingClientRect().left
        const figureBox = this.$el.querySelector('.move')
        const figureBoxWidth = figureBox.clientWidth + 2
        const newPosition = clientX - containerLeft
        this.position = Math.max(
          figureBoxWidth / 2,
          Math.min(container.offsetWidth - figureBoxWidth / 2, newPosition)
        )
      }
    },
    stopDrag() {
      this.dragging = false
      document.removeEventListener('mousemove', this.drag)
      document.removeEventListener('touchmove', this.drag)
      document.removeEventListener('mouseup', this.stopDrag)
      document.removeEventListener('touchend', this.stopDrag)
    }
  }
}
</script>
<style scoped lang="less">
@import url('./index.less');
.loader {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 100%;
  background-color: rgba(119, 115, 115, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  font-size: 15px;
  flex-direction: column;
  color: #fff;
}
.spinner-3 {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: conic-gradient(rgba(206, 200, 200, 0) 10%, #d0d4d4);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: s3 1s infinite linear;
}
@keyframes s3 {
  to {
    transform: rotate(1turn);
  }
}
.moveBtn {
  animation: moveRight 2s ease-in-out forwards;
}
@keyframes moveRight {
  0% {
    transform: translateX(-300px);
  }
  100% {
    transform: translateX(0px);
  }
}
.dots-1 {
  width:50px;
  height:12px;
  background: radial-gradient(circle closest-side,currentColor 90%,#0000) 0 0/33% 100% space;
  clip-path: inset(0 100% 0 0);
  animation:d1 1s steps(4) infinite;
}
@keyframes d1 {to{clip-path: inset(0 -34% 0 0)}}
</style>
